import {FC} from "react";
import {ICraigRoute} from "./craigContext";
import useCraig from "./useCraig";

interface Props {
  route?: ICraigRoute;
  element: JSX.Element;
}

const CraigRoute: FC<Props> = ({route, element}) => {
  const {route: currentRoute} = useCraig();

  if (!route && !currentRoute) return element;

  if (route && currentRoute && route === currentRoute) return element;

  return null;
};

export default CraigRoute;
